import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "chat", "button"]

  connect() {
    // Set initial state - sidebar starts hidden (translated off-screen)
    this.isOpen = false
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    // First, make it visible but off-screen
    this.sidebarTarget.classList.remove("hidden")

    // Force a reflow to ensure the initial state is applied before animating
    this.sidebarTarget.offsetHeight

    // Animate in
    requestAnimationFrame(() => {
      this.sidebarTarget.classList.remove("translate-x-full", "opacity-0")
      this.sidebarTarget.classList.add("translate-x-0", "opacity-100")
      this.buttonTarget.classList.add("!hidden")
      this.chatTarget.classList.add("mr-6")
    })
  }

  close() {
    this.isOpen = false
    // Animate out
    this.sidebarTarget.classList.remove("translate-x-0", "opacity-100")
    this.sidebarTarget.classList.add("translate-x-full", "opacity-0")
    this.buttonTarget.classList.remove("!hidden")
    this.chatTarget.classList.remove("mr-6")

    // Hide after animation completes
    this.sidebarTarget.addEventListener("transitionend", () => {
      if (!this.isOpen) {
        this.sidebarTarget.classList.add("hidden")
      }
    }, { once: true })
  }
}
